module.exports = __webpack_public_path__ + "media/images/bg/hex-slices-light-green-e65c2b866b39eb2d94bff17220c05c0d.svg";